import { useList, useUnit } from "effector-react"

import reservationSidebarsStore from "stores/reservationSidebars"
import ReservationSidebar, { IReservationSidebarOnCloseParams, IReservationSidebarProps, ReservationSidebarTab } from "components/ReservationSidebar/ReservationSidebar"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import pendingReservationSidebarStore from "stores/pendingReservationSidebar"

const ReservationSidebars = () => {
    const location = useLocation()
    const pendingReservationSidebar = useUnit(pendingReservationSidebarStore.$pendingReservationSidebar)

    useEffect(() => {
        const navState = location.state as { openReservationSidebarId?: string, tab?: ReservationSidebarTab } | null
        if (navState?.openReservationSidebarId) {
            reservationSidebarsStore.show({ reservationId: navState.openReservationSidebarId, initTabIndex: navState.tab ?? ReservationSidebarTab.overview})
            return
        }
        if (pendingReservationSidebar.reservationId) {
            return
        }
        reservationSidebarsStore.clear()
    }, [location.pathname])

    async function handleClose(sidebarProps: IReservationSidebarProps, onCloseParams?: IReservationSidebarOnCloseParams) {
        if (typeof sidebarProps.onClose === "function") {
            sidebarProps.onClose(onCloseParams)
        }
        reservationSidebarsStore.hide(sidebarProps)
    }

    return (
        <>
            {useList(reservationSidebarsStore.list, (props: IReservationSidebarProps, idx) => (
                <ReservationSidebar
                    key={idx}
                    {...props}
                    onClose={onCloseParams => handleClose(props, onCloseParams)}
                />
            ))}
        </>
    )
}

export default ReservationSidebars
